
import $ from "jquery"

import {
  captureMessage,
} from "app/error_reporting"


const INIT_COMPLETE_CLASS = "cell--app--languages--selection-menu--navbar-style__js-init-done"


export interface Selector {
  cell:  string | JQuery | Element
  links: string
}
export interface InputSelector {
  cell?:  string | JQuery | Element
  links?: string
}
const default_selector = {
  cell:  ".cell--app--languages--selection-menu--navbar-style",
  links: ".cell--app--languages--selection-menu--navbar-style__link",
}

class Component {
  protected selector: Selector

  protected $cell: JQuery
  protected $links: JQuery

  constructor(selector?: InputSelector){
    this.selector = Object.assign({}, default_selector, selector)

    this.$cell = $(this.selector.cell)
    this.$links = this.$cell.find(this.selector.links)

    this.bind_action()
  }

  protected bind_action(){
    if (this.$cell.hasClass(INIT_COMPLETE_CLASS)) { return this }

    this.$cell.addClass(INIT_COMPLETE_CLASS)

    this.$links.each((_idx, link) => {
      const $link = $(link)
      // Only "#" should be replaced
      // Other values are assumed to be valid URLs
      if ($link.attr("href") !== "#") { return }

      const locale = $link.data("locale")

      let $link_el_for_url = $()
      switch (locale) {
        case "zh-HK": {
          $link_el_for_url = $("link[hreflang=\"zh-Hant\"]")
          break
        }
        case "zh-TW": {
          $link_el_for_url = $("link[hreflang=\"zh-Hant\"]")
          break
        }
        case "zh-CN": {
          $link_el_for_url = $("link[hreflang=\"zh-Hans\"]")
          break
        }
        case "en": {
          $link_el_for_url = $("link[hreflang=\"en\"]")
          break
        }
      }

      // This can sometimes be >1 elements so unknown reasons
      // But we can still use the value
      if ($link_el_for_url.length >= 1) {
        const new_url = $link_el_for_url.attr("href")

        $link.attr("href", new_url)
        return
      }

      captureMessage(
        "concepts/app/languages/selection_menu/button_style $link_el_for_url absent",
        {
          locale: locale,
          $link_el_for_url_length: $link_el_for_url.length,
        }
      )
    })
  }
}

const Factory = {
  create(selector?: InputSelector){
    return new Component(selector)
  },
}

export {
  Factory,
}
